import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageViewOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-4">
      <GenerateImageOptionButton
        title="Close up"
        value="close up view"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="From above"
        value="view from above"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="From behind"
        value="view from behind"
        onClick={props.updatePrompt}
      />
    </div>
  )
}

export default GenerateImageViewOptions
